import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

export default function OpenModalComponent({ openModal }) {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const className =
    innerWidth < 700 ? "btn-bym-standard" : "btn-bym-standard pull-right";
  const style = innerWidth < 700 ? {} : { paddingRight: 20 };

  return (
    <Button className={className} style={style} onClick={openModal}>
      <FontAwesomeIcon
        icon={faPlus}
        style={{ color: "#ffa500", paddingTop: 3, paddingRight: 10 }}
        size="lg"
        fixedWidth
      />
      Legg til ny
    </Button>
  );
}
